import React, { ChangeEvent, useEffect } from "react";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import { Grid, Typography } from "@mui/material";
import { Languages } from "@beable/content-types";

interface LanguageProps {
  languageType?: Languages;
  handleTypeChange(type: string): void;
}

export default function Language({
  languageType,
  handleTypeChange,
}: LanguageProps) {
  const [language, setLanguage] = React.useState<string>('');

  useEffect(() => {
    if (languageType) {
      setLanguage(languageType);
    }
  }, [languageType]);

  useEffect(() => {
      handleTypeChange(language);
  }, [language, handleTypeChange]);

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    setLanguage(event.target.value);
  };

  return (
    <Grid container size={12}>
      <Grid size={2}>
        <Typography>Language</Typography>
      </Grid>
      <Grid size={10}>
        <RadioGroup
          aria-label="language"
          value={language}
          onChange={handleChange}
        >
          <FormControlLabel
            value={Languages.English}
            control={<Radio />}
            label={<Typography variant="body2">EN</Typography>}
          />
          <FormControlLabel
            value={Languages.Spanish}
            control={<Radio />}
            label={<Typography variant="body2">ES</Typography>}
          />
          <FormControlLabel
            value={''}
            control={<Radio />}
            label={<Typography variant="body2">ALL</Typography>}
          />
        </RadioGroup>
      </Grid>
    </Grid>
  );
}
